import { Injectable } from '@nestjs/common';
import { ApaMatrixRepository } from './repo/apa-matrix-repo';
import { PPMDataRepository } from '../dpom/repositories/ppm-data.repository';
import { ApaSizeMatrixResponseModel, CommonResponseModel } from '@project-management-system/shared-models';
import { ErrorResponse } from 'packages/libs/backend-utils/src/models/global-res-object';
import { ApaSizeMatrixBDto } from './dto/apa-matrix.dto';
import { ApaSizeMatrixEntity } from './entity/apa-matrix.entity';
import { APaSizeMatrixAdapter } from './adapters/apa-size-matrix.adapter';
import { StyleRepo } from '../po-bom/dto/style-repo';


@Injectable()
export class ApaSizeMatrixService {
    constructor(
        private Repo: ApaMatrixRepository,
        private adaptor : APaSizeMatrixAdapter,
        private styleRepo : StyleRepo
    ) { }
  
   

    async createApaSizeMatrix(req: ApaSizeMatrixBDto[], isUpdate: boolean): Promise<ApaSizeMatrixResponseModel> {
        try {
         
            const recordsToSave = req.map(record => {
                const adapterData = this.adaptor.convertDtoToEntity(record);
                if (isUpdate) {
                    adapterData.id = record.id;
                    adapterData.updatedUser = record.createdUser;
                } else {
                    adapterData.createdUser = record.createdUser;
                }
                return adapterData;
            });
    
            await this.Repo.save(recordsToSave);
    
            return new ApaSizeMatrixResponseModel(true, 200, 'Created Successfully');
        } catch (err) {
            throw err;
        }
    }
    async updateApaSizeMatrix(req: ApaSizeMatrixBDto[], isUpdate: boolean): Promise<ApaSizeMatrixResponseModel> {
        try {
            console.log(req, 'req');
    
            if (isUpdate) {
                const recordIds = req.map(r => r.id);
                const existingRecords = await this.Repo.findByIds(recordIds);
    
                // Create a map of existing records for easy lookup
                const existingRecordsMap = new Map(existingRecords.map(record => [record.id, record]));
    
                const recordsToUpdate = req.map(record => {
                    const existingRecord = existingRecordsMap.get(record.id);
                    if (existingRecord) {
                        const adapterData = this.adaptor.convertDtoToEntity(record);
                        adapterData.id = existingRecord.id; 
                        adapterData.updatedUser = record.createdUser; // Update the user
                
                        Object.keys(adapterData).forEach(key => {
                            if (adapterData[key] === '') {
                                delete adapterData[key]; // Remove keys with empty values
                            }
                        });
                
                        return adapterData;
                    }
                    return null;
                }).filter(record => record !== null);
                
    
                await this.Repo.save(recordsToUpdate);
    
                return new ApaSizeMatrixResponseModel(true, 200, 'Updated Successfully');
            } else {
                const recordsToSave = req.map(record => {
                    const adapterData = this.adaptor.convertDtoToEntity(record);
                    adapterData.createdUser = record.createdUser;
                    return adapterData;
                });
    
                await this.Repo.save(recordsToSave);
    
                return new ApaSizeMatrixResponseModel(true, 200, 'Created Successfully');
            }
        } catch (err) {
            throw err;
        }
    }
    
    
    async getAllApaSizeData(styleNumber : string):Promise<ApaSizeMatrixResponseModel>{
        try{
            const data : any = await this.Repo.find({where : {styleNumber }})
            const styleId = await this.styleRepo.findOne({where : {style : styleNumber},select:['id']})
            data.forEach((v) => {
                v.styleId = styleId.id
            })
            if (data.length > 0){
                return new ApaSizeMatrixResponseModel(true, 101 ,'Data Retrived Successfully',data)

            }
            else {
                return new ApaSizeMatrixResponseModel(false, 1000 ,'Data Not Retrived Successfully')

            }
        }
        catch (err){
            throw err;
        }
    }
    
    async getAllApaSizeViewData():Promise<ApaSizeMatrixResponseModel>{
        try{
            let query= `SELECT id , buy_month AS buyMonth ,fd_of AS fdof ,style_number AS styleNumber,style_type as styleType , usa_size AS usaSize , china_size_matrixtype AS chinaSizeMatrixType , korea_size_matrixtype AS koreaSizeMatrixtype
                        FROM apa_size_matrix GROUP BY style_number ORDER BY id ASC`
            const data = await this.Repo.query(query)
            if (data.length > 0){
                return new ApaSizeMatrixResponseModel(true, 101 ,'Data Retrived Successfully',data)

            }
            else {
                return new ApaSizeMatrixResponseModel(false, 1000 ,'Data Not Retrived Successfully')

            }
        }
        catch (err){
            throw err;
        }
    }
}
